import { useState } from 'react';
import cls from 'classnames';
import ReactAvatar from 'react-avatar';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Skeleton } from '@bfe/moly';

import styles from './index.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

export interface IProps {
  size: string;
  src: string;
  name?: string;
  className?: string;
  color?: string;
}

enum Status {
  IDLE = 'IDLE',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

// 支持resize
export const Avatar = (props: IProps) => {
  const { className, name, src, size, color = '#25282C' } = props;
  const [status, setStatus] = useState<Status>(Status.IDLE);

  const style = { width: `${size}px`, height: `${size}px` };

  const handleImgUrl = (url: string) => {
    try {
      const urlObj = new URL(url);

      return urlObj.href;
    } catch {
      return url;
    }
  };

  const initials = (name: string) => {
    if (!name) return '';
    return name.replace(/\s/, '').substring(0, 1);
  };

  return (
    <div className={cls(styles.container, className)} style={style}>
      {src && status !== Status.ERROR ? (
        <>
          <LazyLoadImage
            className={cls(styles.image, {
              [styles.hidden]: status === Status.IDLE,
            })}
            src={handleImgUrl(src)}
            effect="blur"
            alt="dex_icon"
            width={size}
            height={size}
            onLoad={() => setStatus(Status.LOADED)}
            onError={() => setStatus(Status.ERROR)}
            style={style}
          />
          {status === Status.IDLE && <Skeleton.Ball style={style} />}
        </>
      ) : (
        <div className={styles.fallback}>
          <ReactAvatar
            className={styles.avatar}
            name={name}
            size={size}
            initials={initials}
            color={color}
            textSizeRatio={2}
            round
          />
        </div>
      )}
    </div>
  );
};
